import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { Product } from '../../models/products-model/products.model';
import { CdkAutofill } from '@angular/cdk/text-field';
import { ProductsService } from '../../services/products.service';

@Component({
  selector: 'app-card-product',
  imports: [MatIcon, MatButtonModule, CommonModule, CdkAutofill],
  templateUrl: './card-product.html',
  styleUrl: './card-product.css',
})
export class CardLocations {
  @Input() small: boolean = false;
  @Input() product: Product | null = null;
  @Input() added: boolean = false;

  constructor(private productsService: ProductsService) {}

  public addProduct() {
    console.log('product', this.product);
    if (!this.added) {
      this.product!.added = true;
      this.product!.amount = 1;
    } else {
      this.product!.added = false;
      this.product!.amount = 0;
    }
    this.productsService.emitProduct.emit(this.product!);
  }
}
